import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import CardDesigner from '../../../components/global/CardDesigner';
import useOpenAlert from '../../../hooks/useOpenAlert';
import { CARD_SIDE } from '../../../services/cards/constants';

const CardDesignerView = ({ location }) => {
  const openAlert = useOpenAlert();
  const query = qs.parse(location?.search);
  const { side = CARD_SIDE.FRONT, cardSideId } = query ?? {};

  return (
    <CardDesigner
      defaultCardSide={side}
      defaultCardSideId={cardSideId}
      onComplete={({ card }) =>
        openAlert({
          message: `Card saved! Your card id is: ${card.id}`,
        })
      }
    />
  );
};

export default withRouter(CardDesignerView);
